import React, { useState } from 'react';
import classNames from 'classnames';

import { CircleChevronDown } from '../Icons';
import styles from './styles.module.css';

export type AccordianPropsType = {
  title: string | React.ReactNode;
  initOpen?: boolean;
  className?: string;
  children?: React.ReactNode;
  triggers?: {
    expand: React.ReactNode;
    collapse: React.ReactNode;
  };
};

export const Accordian: React.FC<AccordianPropsType> = ({
  initOpen,
  title,
  className,
  triggers,
  children,
}) => {
  const [open, setOpen] = useState<boolean>(!!initOpen);

  const arrowClass = classNames(styles.arrow, {
    [styles.activeArrow]: open,
  });
  const triggerClass = classNames(styles.trigger, {
    [styles.activeTrigger]: open,
  });
  const contentClass = classNames(styles.content, {
    [styles.activeContent]: !open,
  });

  const renderCustomTrigger = () => {
    if (open) {
      return triggers?.collapse;
    }
    return triggers?.expand;
  };

  const renderTrigger = () => {
    if (triggers) {
      return renderCustomTrigger();
    }

    return <CircleChevronDown className={arrowClass} />;
  };

  return (
    <div className={className} data-testid="accordion">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className={triggerClass}
        data-testid="button"
      >
        {title}

        {renderTrigger()}
      </button>

      <div className={contentClass} data-testid="content">
        <div className={styles.contentInner}>{children}</div>
      </div>
    </div>
  );
};
